<template>
    <v-expansion-panels :value="0" class="expansion-reenrollment mb-12" readonly flat>
        <v-expansion-panel>
            <v-expansion-panel-header class="expansion-reenrollment__header" hide-actions>
                <div class="d-flex align-center py-1">
                    <v-checkbox
                        v-model="selectedall"
                        class="mt-0 mr-3 pt-0"
                        color="primary"
                        hide-details
                        ></v-checkbox>
                        <!-- :disabled="hasAdaptationInsurance || generatePaymentIds"
                        @change="selectAll" -->
                    <h3 class="flex-grow-1 font-weight-medium">{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.complex.nextTermInscription') }}</h3>
                    <div class="message font-weight-medium text-center">{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.complex.extraDiscount') }}</div>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div :class="['d-flex expansion-reenrollment__content', { 'bottom-border': !showExtraBenefitBanner, 'flex-column': !showCompacted || $vuetify.breakpoint.smAndDown } ]">
                    <div v-for="(payment, i) in reenrollmentPayments" :key="payment.id">
                        <NewPaymentComplex v-if="showCompacted" :payment="payment" disabledPrepaid :class="applyCompactStyle(i)">
                            <v-checkbox
                              class="mt-0 mr-3 pt-0"
                              color="primary"
                              :disabled="payment.options.disabled"
                              :input-value="payment.selected"
                              @change="$emit('updatepaymentmethod', $event, i)"
                              hide-details
                          ></v-checkbox>
                          <div>
                              <h4 class="font-weight-medium" style="line-height: 1;">{{ payment.title }}</h4>
                              <small v-if="payment.billingProduct == $sisConstants('modules.products.matricula')" class="font-weight-medium">
                                  {{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.complex.matDuration') }}
                              </small>
                              <small v-else-if="$isMexico" class="d-flex mt-1 font-weight-medium" style="line-height: 1.17;">
                                  {{ $options.filters.$capitalize(getFormattedDate(payment.options.dueDate, 'MMMM')) }}
                              </small>
                              <small v-else-if = "payment.billingProduct != 248" class="d-flex mt-1 font-weight-medium" style="line-height: 1.17;">
                                  {{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.complex.termDuration', { startDate: getFormattedDate(payment.options?.term?.classStartDate, 'MMMM'), endDate: getFormattedDate(payment.options?.term?.classEndDate, 'MMMM') }) }}
                              </small>
                              <div class="d-flex flex-column justify-center pt-1">
                                  <small v-if="payment.options.off > 0" class="old-price">{{ payment.options.amount | $currency }}</small>
                                  <small v-else style="line-height: 1.21;">&nbsp;</small>
                                  <span class="font-weight-medium text-no-wrap">{{ payment.options.amount * (1 - payment.options.off / 100) | $currency }}</span>
                                  <span v-if="payment.options.off > 0" class="discount-value">{{ `${Math.round((payment.options.off + Number.EPSILON) * 100) / 100}% OFF` }}</span>
                              </div>
                          </div>
                        </NewPaymentComplex>
                        <NewPaymentComplex v-else :payment="payment"  @updatepaymentmethod="$emit('updatepaymentmethod', $event, i)" />
                    </div>
                </div>
                <div v-if="showExtraBenefitBanner" class="extraBenefitBanner d-flex align-center px-6 py-4">
                    <v-icon color="#2C9200" class="icon pa-2 mr-3">mdi-bell</v-icon>
                    <strong>{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.moreDiscountsNextStep', { discount: extraBenefitDiscount }) }}</strong>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import moment from 'moment'
    import NewPaymentComplex from './NewPaymentComplex.vue'

    export default {
        name: 'ReenrollmentComplex',
        components: {
            NewPaymentComplex
        },
        props: {
            reenrollmentPayments: Array,
            extraBenefitDiscount: { type: Number, default: 0 },
            systemConfig: Object,
            hasUserInteracted: {type: Boolean, default: true},
            hasInitalSelectionPayments: {type: Boolean, default: false},
        },
        data() {
            return {
              selectedall: true
            }
        },
        computed: {
            showExtraBenefitBanner() {
                return this.extraBenefitDiscount > 0
            },
            showCompacted() {
                return this.reenrollmentPayments.length <= 3
            },
            hasEverythingSelected(){
              return this.reenrollmentPayments.every(payment => payment.selected)
            }
        },
        methods: {
            getFormattedDate(date, format = 'DD-MM-YYYY') {
                return moment(date).format(format)
            },
            applyCompactStyle(index){
              return [
                'd-flex flex-grow-1 payment',
                {
                    'border-left': this.reenrollmentPayments.length > 1 && index != 0,
                    'border-right': this.reenrollmentPayments.length == 1,
                    'px-6 my-6': this.showCompacted,
                }
              ]
            }
        },
        watch:{
          selectedall:{
            handler(toggle){
              if(toggle || this.hasEverythingSelected ){
                this.$emit('updatepaymentmethod', toggle, -1, this.selectedall)
              }
            },
            immediate: true
          },
          reenrollmentPayments:{
            handler(paymentsNext){
              if(!this.hasUserInteracted){
                paymentsNext.forEach(payment=> payment.selected = this.hasInitalSelectionPayments 
                    && (this.studentData?.careerStatus?.value != 51 ? true : !payment.independent))
              }
              this.selectedall = this.hasEverythingSelected
            },
            deep:true,
            immediate:true
          }
        }
    }
</script>

<style scoped lang="scss">
    .expansion-reenrollment {
        font-family: 'DM Sans';

        &__header {
            background-color: #B3CCFF;
            border-radius: 10px 10px 0 0;

            .message {
                background-color: white;
                padding: 6px 12px;
                border-radius: 24px;
                font-size: 12px;
                line-height: 1;
                color: var(--v-primary-base);
            }
        }
        ::v-deep .v-expansion-panel-content__wrap {
            padding: 0;
            background-color: var(--v-primary-lighten5);
            border-radius: 0 0 10px 10px;
        }
        &__content {
            border-left: 2px solid #B3CCFF;
            border-right: 2px solid #B3CCFF;

            &.bottom-border {
                border-bottom: 2px solid #B3CCFF;
                border-radius: 0 0 10px 10px;
            }
        }

        .payment {
            &.border-left { border-left: 1px solid #B3CCFF; }
            &.border-right { border-right: 1px solid #B3CCFF; }

            .old-price {
                line-height: 1.21;
                color: rgba(33, 33, 33, 0.5);
                text-decoration: line-through;
            }

            .discount-value {
                font-size: 14px;
                color: #2d9400;
            }
        }

        .extraBenefitBanner {
            background-color: #D7FFBE;
            color: #2C9200;
            border: 2px solid #A2E578;
            border-radius: 0 0 10px 10px;
            .icon {
                background-color: #B2F799;
                border-radius: 50%;
            }
        }
    }
</style>
